import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  validatePurchaseForFields,
  validatePurchaseForSaleFields
} from "MODULES/PurchaseOrders/shared/validations";
import {
  AS_REMOVED,
  CORE_REPAIR_FEE_NOT_TO_EXCEED,
  HAZMAT_FEE,
  PERCENT_INSURED,
  PREFERRED_REPAIR_STATION_ID
} from "MODULES/PurchaseOrders/constants";
import { BUYER_CREDIT_PCT, COST, QUANTITY } from "APP_ROOT/constants";
import {
  CONDITION,
  EXCHANGE_SRP,
  INSPECTED,
  LEAD_TIME,
  OVERHAULED,
  PART_ID,
  REPAIRED,
  SRP_CONDITION,
  TAG_DATE,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { DOM } from "MODULES/parts/constants";
import {
  CORE_DUE_DAYS,
  CORE_RETURN_DATE
} from "MODULES/RepairOrders/constants";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { isEmpty } from "lodash";

export default function validate(values, props) {
  return validator(values, form => {
    form
      .validate(PART_ID, CONDITION, QUANTITY, BUYER_CREDIT_PCT)
      .satisfies(rules.required);

    form.validate(LEAD_TIME).satisfies(rules.requiredAllowZero);

    if (Number(props.lot.cost_split) === 0) {
      form
        .validate(COST)
        .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0));
    }

    if (values.reserve_for_sale_quantity) {
      form
        .validate(QUANTITY)
        .satisfies(
          rules.isGreaterThanOrEqualTo(values.reserve_for_sale_quantity)
        );
    } else if (values.quantity_received) {
      form
        .validate(QUANTITY)
        .satisfies(rules.isGreaterThanOrEqualTo(values.quantity_received));
    } else {
      form.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    }

    form.validate(PERCENT_INSURED).satisfies(rules.isBetween(1, 100));

    if (values.hazmat) {
      form
        .validate(HAZMAT_FEE)
        .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0));
    }

    if (values.purchase_for_stock && !isEmpty(values.srp_condition)) {
      form.validate(SRP_CONDITION).satisfies(rules.matches(CONDITION));
    }

    if (
      (props && props.domLifeYears && props.llp) ||
      (props.selectedPart && props.selectedPart.dom_sensitive)
    ) {
      form.validate(DOM).satisfies(rules.required);
    }

    if (
      (values.purchase_for_repair ||
        (values.condition === AS_REMOVED &&
          !values.purchase_for_sale &&
          !values.purchase_for_stock)) &&
      ((props.selectedLineItem && !props.selectedLineItem.consignment) ||
        !props.selectedLineItem)
    ) {
      form.validate(PREFERRED_REPAIR_STATION_ID).satisfies(rules.required);
    }

    if ([OVERHAULED, INSPECTED, REPAIRED].includes(values.condition)) {
      form.validate(TAG_DATE).satisfies(rules.required);
      form.validate(TAGGED_BY).satisfies(rules.required);
    }

    if (values.purchase_for_exchange) {
      form
        .validate(CORE_DUE_DAYS, CORE_RETURN_DATE, EXCHANGE_FEE)
        .satisfies(rules.required);
      form.validate(QUANTITY).satisfies(rules.mustBeOne);

      if (values.flat_exchange) {
        form.validate(CORE_REPAIR_FEE_NOT_TO_EXCEED).satisfies(rules.required);
      }
    }

    if (values.exchange_srp && props.minExchangeSrp) {
      form
        .validate(EXCHANGE_SRP)
        .satisfies(rules.isGreaterThanOrEqualTo(props.minExchangeSrp));
    } else if (values.exchange_srp) {
      form.validate(EXCHANGE_SRP).satisfies(rules.isGreaterThan(0));
    }

    validatePurchaseForFields(values, form);
    validatePurchaseForSaleFields(values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/validate.js